import { setBalanceAction } from 'core/widgets/User/actions';
import { setWinStatusAction } from 'core/widgets/WinStatus/actions';
import { WinnerBallSlot } from 'core/widgets/WinStatus/types';
import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { OnPlayerResultData } from '../types';

export function* onPlayerResultSaga({ type: notificationType, data: result }: OnPlayerResultData) {
  if (notificationType === Notifications.PLAYER_RESULT) {
    const { betAmount, winAmount, currency, drawResult } = result;
    // const betAmount = bets[WinnerBallSlot[winner]];

    // yield put(setBalanceAction(balance)); ??????
    yield put(
      setWinStatusAction({
        winner: drawResult,
        winningAmount: winAmount || 0,
        betAmount: betAmount || 0,
      }),
    );
  }
}
